import { FieldTypes } from '@domain-group/realhub-backend-api-types'
const state = {
  agency_id: undefined,
  agency_marketing: false,
  agent_ids: undefined,
  air_conditioning: false,
  auction_date: '',
  bathrooms: '',
  bedrooms: '',
  building_area: '',
  building_area_units: '',
  campaign_category_id: undefined,
  campaign_status_id: undefined,
  campaign_type_id: undefined,
  campaign_rural_category_id: undefined,
  campaign_sale_method_id: undefined,
  canva_integrated: false,
  car_spaces: undefined,
  carparks: '',
  carports: '',
  council_rates: '',
  country_code: '',
  data: {},
  dining_rooms: '',
  dishwasher: false,
  end_date: '',
  energy_rating: '',
  extra_fields: {},
  facilities: '',
  floorboards: false,
  frontage: null,
  hidden: false,
  hide_address: false,
  hide_price: false,
  hide_sold_price: false,
  id: null,
  land_area_units: '',
  land_area: null,
  land_details: '',
  land_zoning: '',
  latitude: '',
  legal_description: '',
  living_areas: '',
  longitude: '',
  lot_number: '',
  marketing_agency_id: undefined,
  municipality: '',
  pool_in_ground: false,
  post_code: '',
  price_guide: '',
  price: undefined,
  property_url: '',
  purchaser_aml_complete: undefined,
  reserve_price: undefined,
  site_name: '',
  sold_date: '',
  sold_price: undefined,
  sold: false,
  start_date: '',
  state_id: undefined,
  state_name: '',
  street_name: '',
  street_number: '',
  studies: '',
  suburb_id: '',
  suburb_name: '',
  team_id: undefined,
  title: '',
  under_offer: false,
  unit_number: '',
  vendor_aml_complete: undefined,
  year_built: '',
}

export const fieldTypes: FieldTypes = {
  auction_date: { key: 'auction_date', inputType: 'datetime', label: 'Auction Date' },
  bathrooms: { label: 'Bathrooms', key: 'bathrooms', inputType: 'text' },
  bedrooms: { label: 'Bedrooms', key: 'bedrooms', inputType: 'text' },
  campaign_duration: { label: 'Campaign Duration', key: 'campaign_duration', inputType: 'text' },
  car_spaces: { label: 'Car Spaces', key: 'car_spaces', inputType: 'number' },
  carparks: { label: 'Carparks', key: 'carparks', inputType: 'text' },
  carports: { label: 'Carports', key: 'carports', inputType: 'text' },
  council_rates: { label: 'Council Rates', key: 'council_rates', inputType: 'text' },
  country_code: { label: 'Country Code', key: 'country_code', inputType: 'text' },
  country_name: { label: 'Country Name', key: 'country_name', inputType: 'text' },
  energy_rating: { label: 'Energy Rating', key: 'energy_rating', inputType: 'text' },
  facilities: { label: 'Facilities', key: 'facilities', inputType: 'number' },
  frontage: { label: 'Frontage', key: 'frontage', inputType: 'number' },
  highest_search: { label: 'Price High', key: 'highest_search', inputType: 'number' },
  // @ts-expect-error TS2353
  inspection_details: { label: 'Inspection Details', key: 'inspection_details', inputType: 'text' },
  land_area: { label: 'Land Area', key: 'land_area', inputType: 'number' },
  land_area_units: { label: 'Land Area Units', key: 'land_area_units', inputType: 'text' },
  land_details: { label: 'Land Details', key: 'land_details', inputType: 'text' },
  land_zoning: { label: 'Land Zoning', key: 'land_zoning', inputType: 'text' },
  latitude: { label: 'Latitude', key: 'latitude', inputType: 'number' },
  legal_description: { label: 'Legal Description', key: 'legal_description', inputType: 'text' },
  living_areas: { label: 'Living Areas', key: 'living_areas', inputType: 'text' },
  longitude: { label: 'Longitude', key: 'longitude', inputType: 'number' },
  lot_number: { label: 'Lot Number', key: 'lot_number', inputType: 'text' },
  lowest_search: { label: 'Price Low', key: 'lowest_search', inputType: 'number' },
  municipality: { label: 'Municipality', key: 'municipality', inputType: 'text' },
  post_code: { label: 'Post Code', key: 'post_code', inputType: 'text' },
  price: { label: 'Price', key: 'price', inputType: 'number' },
  price_guide: { label: 'Price Guide', key: 'price_guide', inputType: 'text' },
  property_url: { label: 'Property Url', key: 'property_url', inputType: 'text' },
  published: { label: 'Published', key: 'published', inputType: 'boolean' },
  rental_bond: { label: 'Rental Bond', key: 'rental_bond', inputType: 'number' },
  rental_period: { label: 'Rental Period', key: 'rental_period', inputType: 'text' },
  reserve_price: { label: 'Reserve Price', key: 'reserve_price', inputType: 'number' },
  site_name: { label: 'Site Name', key: 'site_name', inputType: 'text' },
  sold: { label: 'Sold', key: 'sold', inputType: 'boolean' },
  sold_price: { label: 'Sold Price', key: 'sold_price', inputType: 'number' },
  start_date: { label: 'Start Date', key: 'start_date', inputType: 'date' },
  state_name: { label: 'State Name', key: 'state_name', inputType: 'date' },
  street_name: { label: 'Street Name', key: 'street_name', inputType: 'text' },
  street_number: { label: 'Street Number', key: 'street_number', inputType: 'text' },
  studies: { label: 'Studies', key: 'studies', inputType: 'text' },
  suburb_name: { label: 'Suburb Name', key: 'suburb_name', inputType: 'text' },
  title: { label: 'Title', key: 'title', inputType: 'text' },
  under_offer: { label: 'Under Offer', key: 'under_offer', inputType: 'boolean' },
  unit_number: { label: 'Unit Number', key: 'unit_number', inputType: 'text' },
  year_built: { label: 'Year Built', key: 'year_built', inputType: 'text' },
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'street_name' },
  { key: 'street_number' },
  { key: 'suburb_name' },
]

export default state
